<template>
  <div style="display: flex;">
    <div style="width: 360px;">
      <div style="min-height: 800px; border-radius: 10px; border: 1px solid #ccc;">
        <div style="font-size: 28px; display: flex; justify-content: center; align-items: center;">
          <el-skeleton>
            <template slot="template">
              <el-skeleton-item variant="image" style="width: 320px; height: 300px;margin-top: 20px;" />
              <div style="padding: 14px;">
                <el-skeleton-item variant="p" style="width: 50%" />
                <div
                  style="display: flex; align-items: center;"
                >
                  <el-skeleton-item variant="text" style="margin-right: 16px;" />
                  <el-skeleton-item variant="text" style="width: 30%;" />
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>
        <div>
          <div style="margin: 20px 0 0 40px; color: #000;">属性:</div>
          <div style="margin: 10px 0 0 60px; color: darkred">
            <div v-for="(item,index) in baseattrtb" :key="index" style="margin-bottom: 10px;">
              <div>{{item.name}}<span style="margin-left: 5px; color: #cccccc">(注释：键值需要新增产品时设置)</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1;margin: 0 20px 0 20px;">
      <div style="padding: 40px; border: 1px solid #ccc; color: #000; border-radius: 10px;">
        <div>属性名称：</div>
        <div style="margin-top: 5px;margin-top: 20px;">
          <el-input v-model="curattrname" placeholder="请输入属性名称"></el-input>
        </div>
        <div style="padding-left: 0px; margin-top: 20px;">
          <el-button @click="addbaseattr" type="primary" icon="el-icon-plus" style="margin-top: 5px;">新增属性</el-button>
          <el-button @click="changecurattr" type="success" icon="el-icon-edit-outline" style="margin-top: 5px;">保存属性</el-button>
        </div>
      </div>
      <div style="padding: 40px; margin-top: 20px; border: 1px solid #ccc; border-radius: 10px;">
        <el-table
          :header-cell-style="{'text-align':'center'}"
          :data="baseattrtb">
          <el-table-column
            prop="name"
            label="名称"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="150px"
          >
            <template slot-scope="scope">
              <div class="inopicondiv">
                <i class="fa fa-eye opicon curpointer" v-on:click="changeattrname(scope.$index, baseattrtb)"> 编辑 </i>
                <i class="fa fa-trash-o opicon curpointer" v-on:click="removebaseattr(scope.$index, baseattrtb)"> 删除 </i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GAttrs',
    data () {
      return {
        curattrname: '',
        selectattr: '',
        baseattrtb: [],
        khid: '',
        selattrid: ''
      }
    },
    mounted () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.$options.methods.getbaseattr()
      }
    },
    methods: {
      /**
       * 添加属性到分组
       * @param id
       */
      saveattrtotype (id) {
        var adata = {
          id: '',
          attr_type_id: '0',
          attr_id: id.toString(),
          attr_name: that.curattrname,
          ownphone: localStorage.getItem('username'),
          cusid: localStorage.getItem('cusid').toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addbgag',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$emit('getattrs');
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      /**
       * 获取属性列表
       */
      getbaseattr () {
        var qstr = {
          whereinfo: 'ownphone = ' + localStorage.getItem('username') + ' and type=0',
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querbga',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.length > 0) {
              that.baseattrtb = res.data
            } else {
              that.baseattrtb = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      /**
       * 增加基础属性
       */
      addbaseattr () {
        if (this.curattrname === null || this.curattrname === '') {
          that.$message({
            type: 'info',
            message: '基础属性需要填写！！'
          })
        } else {
          var adata
          adata = {
            id: '',
            name: this.curattrname,
            type: '0',
            cusid: this.khid.toString(),
            ownphone: localStorage.getItem('username')
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/addbga',
            method: 'post',
            data: adata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log('已获取网络数据')
              if (res.data.result === 'success') {
                that.saveattrtotype(res.data.data)
                that.getbaseattr()
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      /**
       * 更新基础属性
       */
      changecurattr () {
        var adata
        adata = {
          id: this.selattrid.toString(),
          name: this.curattrname,
          type: '0',
          cusid: this.khid.toString(),
          ownphone: localStorage.getItem('username')
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addbga',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('已获取网络数据')
            if (res.data.result === 'success') {
              that.getbaseattr()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      changeattrname (index, data) {
        console.log(data[index])
        this.selattrid = data[index].id
        this.curattrname = data[index].name
      },
      /**
       * 删除属性
       * @param index
       * @param data
       */
      removebaseattr (index, data) {
        var curselectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delbga',
          method: 'post',
          data: {
            id: curselectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.getbaseattr()
            } else {
              that.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
          .catch(function (error) {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
            console.log('error' + error)
          })
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/GAttrs.vue